<template>
    <Buy/>
</template>

<script>
// @ is an alias to /src
import Buy from '../components/Buy.vue'

export default {
  name: 'buy',
  components: {
    Buy
  }
}
</script>
